/*eslint-disable*/
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";
import ListIcon from '@material-ui/icons/List';

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Product categories"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={ListIcon}
          dropdownList={[
            <Link to="/cosmetics" target="" className={classes.dropdownLink}>
              Cosmetics
            </Link>,
            <Link to="/detergents" className={classes.dropdownLink}>
              Detergents
            </Link>,
            <Link to="/packaging" className={classes.dropdownLink}>
              Packaging
            </Link>,
            <Link to="/granules" className={classes.dropdownLink}>
              Plastic granules
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button href="/search" color="transparent" className={classes.navLink}>
          Database
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          // href="/contact"
          href="https://docs.google.com/forms/d/e/1FAIpQLScyPa9F_sWockEfvxPys0tfTxqi-L5vw4MC1Q23l-quu_qFhQ/viewform?usp=sf_link"
          color="transparent"
          target="_blank"
          className={classes.navLink}
        >
          Contact
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Kövess Facebook-on"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.facebook.com/ultragreencert"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-facebook"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="Kövess Instagram-on"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/ultragreencert"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}
